var platformCheck = platformCheck || {};
var TweenMax = TweenMax || {};
var TimelineMax = TimelineMax || {};
var site = site || {};
var hashHelper = hashHelper || {};

(function ($) {
  'use strict';

  Drupal.behaviors.SPPHowToV1 = {
    attach: function (context, settings) {
      // DOM
      var $SPPHowToUse = $('.spp_how-to-use', context);
      var $window = $(window);

      // Assign classes based on platform and begin tracking resize
      platformCheck({
        target: $SPPHowToUse.toArray(),
        mobileSize: 767,
        mobileClass: 'js-mobile',
        desktopClass: 'js-desktop',
        ipadClass: 'js-ipad',
        ieClass: 'js-ie',
        isMobileCallback: function () {
          return typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        }
      });

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: SPP Sections
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $carouselPrev = $SPPHowToUse.find('.carousel_pagers .previous');
        var $carouselNext = $SPPHowToUse.find('.carousel_pagers .next');
        var $carousels = $SPPHowToUse.find('.carousel');
        // LOGIC
        var hasCarousels = false; // Should only be set by carouselInit or carouselDestroy
        var carouselSettings = {
          increment: '100%',
          offset: '0%',
          ignoreTargets: '.ignore',
          debug: false,
          useGSAP: false,
          duration: 1,
          callbackAnimation: (function () {
            var init = false;
            var prevSlideIndex = 0;
            var timeline = new TimelineMax();

            return function () {
              var _this = this;
              // DOM
              var $targetSlide = $(_this.slides[0]);
              // LOGIC
              var targetSlideIndex = $targetSlide.index();

              if (typeof $(_this.$target).data('elCarousel') === 'undefined') {
                init = false;
              }

              // Initialize carousels
              if (!init) {
                // Position all slides
                _this.slides.forEach(function (element, index) {
                  TweenMax.set(element, { x: 100 * index + '%' });
                });

                $(_this.slides[0]).addClass('active').siblings().removeClass('active');
                init = true;
              // Update positions for each
              } else {
                // Do not animate if already on target slide
                if (prevSlideIndex === targetSlideIndex) {
                  return;
                }

                _this.$target.trigger('carousel_updated', targetSlideIndex);

                _this.$target.children().each(function () {
                  var $this = $(this);

                  timeline.to($this, 0.5, { x: 100 * $this.index() - (100 * targetSlideIndex) + '%' }, $this.index() === 0 ? '+=0' : '-=0.5');
                });

                $targetSlide.addClass('active').siblings().removeClass('active');
              }

              prevSlideIndex = targetSlideIndex;
            };
          })()
        };

        /**
        * @function carouselInit
        * @description Initializes carousels in the page
        * @returns {undefined} Nothing
        */
        function carouselInit() {
          // All carousel start from the first slide
          $carouselPrev.css({ display: 'none' });

          $carousels.each(function () {
            var $this = $(this);
            var $template = $this.closest('.spp_how-to-use').find('.carousel_pagination li.template');

            // Assumes the dotnav hasn't already been created
            if ($template.length !== 0) {
            // Create dot navs
              $this.children().not(':first-child').each(function () {
                $template.parent().append($template.clone().removeClass('template'));
              });

              // Template dot nav becomes first
              $template.removeClass('template').addClass('active');
            }

            // Create carousel for each
            if (!hasCarousels) {
              $this.elCarousel(carouselSettings);
            }

            $this.elCarouselUpdate();
          });
          hasCarousels = true;
        }

        /**
        * @function carouselDestroy
        * @description Removes carousel styling and functionality from existing carousels
        * @returns {undefined} Nothing
        */
        function carouselDestroy() {
          if (!hasCarousels) {
            return;
          }

          $carousels.each(function () {
            $(this).elCarouselDestroy();
            $(this).children().removeAttr('style');
          });

          hasCarousels = false;
        }

        // BEGIN: Events
        $window.on('resize updateSPPCarousels', _.debounce((function () {
          var previousWidth = -1;

          return function () {
            var windowWidth = $window.width();

            // On platforms other than mobile, clear height and remove carousel functionality
            if (windowWidth > 767) {
              $SPPHowToUse.removeClass('js-mobile').addClass('js-desktop');
              $carousels.css({ height: '' });
              carouselDestroy();

              return;
            }

            $SPPHowToUse.addClass('js-mobile').removeClass('js-desktop');

            // Attempt to create carousels
            carouselInit();

            if (previousWidth === windowWidth) {
              return;
            }

            $carousels.each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var largest = 0;

              $this.children().each(function () {
                if ($(this).outerHeight(true) > largest) {
                  largest = $(this).outerHeight(true);
                }
              });

              $this.height(largest);
            });

            previousWidth = windowWidth;
          };
        })()));

        // Opens and closes SPP instructions on mobile
        $SPPHowToUse.find('.spp-product__additional-section-button').on('click', function (e) {
          e.preventDefault();

          if ($window.width() < 767) {
            $(this).closest('.spp_how-to-use').toggleClass('is_closed');
          }
        });

        // Progress carousel
        $carouselNext.on('click', function (e) {
          var $carousel = $(this).closest('.spp_how-to-use').find('.carousel');

          e.preventDefault();

          if ($carousel.length !== 0) {
            if ($carousel.children().last().hasClass('active')) {
              return;
            }

            $carousel.elCarouselNext();
          }
        });

        // Reverse carousel
        $carouselPrev.on('click', function (e) {
          var $carousel = $(this).closest('.spp_how-to-use').find('.carousel');

          e.preventDefault();

          if ($carousel.length !== 0) {
            if ($carousel.children().first().hasClass('active')) {
              return;
            }

            $carousel.elCarouselPrev();
          }
        });

        // Swipe triggers carousel clicks
        $carousels.swipe({
          swipeLeft: function () {
            $(this).closest('.spp_how-to-use').find('.next').trigger('click');
          },
          swipeRight: function () {
            $(this).closest('.spp_how-to-use').find('.previous').trigger('click');
          }
        });

        // Dot nav click
        $SPPHowToUse.on('click', '.carousel_pagination li', function (e) {
          var $this = $(this);
          var $carousel = $this.closest('.spp_how-to-use').find('.carousel');

          e.preventDefault();

          if ($carousel.length !== 0) {
            $carousel.elCarouselTo($this.index());
            $this.addClass('active').siblings().removeClass('active');
          }
        });

        $carousels.on('carousel_updated', function (e, slideIndex) {
          var $this = $(this);

          // Update dot nav
          $this.closest('.spp_how-to-use').find('.carousel_pagination li').not('.template').eq(slideIndex).addClass('active').siblings().removeClass('active');

          // Reset prev next buttons
          $this.closest('.spp_how-to-use').find('.next, .previous').css({ display: '' });

          // Hide "previous" button on first slide
          if (slideIndex === 0) {
            $this.closest('.spp_how-to-use').find('.previous').css({ display: 'none' });
            // Hide "next" button on last slide
          } else if (slideIndex === $this.children().length - 1) {
            $this.closest('.spp_how-to-use').find('.next').css({ display: 'none' });
          }
        });
        // END: Events

        // BEGIN: Post Init
        $window.trigger('updateSPPCarousels');
        // END: Post Init
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: SPP Sections
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $targetImages;
        var $deeplinkTarget;
        // LOGIC
        var deeplinkData = hashHelper.get();

        // Deeplink to the SPP section
        deeplinkData.forEach(function (target) {
          $deeplinkTarget = $SPPHowToUse.filter('[data-deeplink="' + target + '"]');
        });

        if (typeof $deeplinkTarget !== 'undefined' && $deeplinkTarget.length !== 0) {
          TweenMax.to($window, 1, {
            scrollTo: {
              y: $deeplinkTarget.offset().top - $('header').eq(0).outerHeight(),
              autoKill: false
            }
          });
        }

        // Get all images before the target section images as well, as content may be sized to loaded images
        $targetImages = $SPPHowToUse.find('img');
        $targetImages.FreeLoader({
          callback: function () {
            // Mark boutique as loaded
            $SPPHowToUse.addClass('loaded');

            //  Load other (boutique) images normally
            $SPPHowToUse.find('img').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var imageLink = $this.attr('data-src');

              if (typeof imageLink === 'string' && imageLink.trim().length !== 0) {
                $this.attr('src', imageLink);
              }
            });
          }
        });
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
    }
  };
})(jQuery);
